import { EmailValidator, PhoneValidator } from '../../utilities/commonValidators'

export const validate = (values) => {
  const errors = {}

  if (!values.name) {
    errors.name = 'Required'
  }
  if (values.name && values.name.length > 100) {
    errors.name = 'Account Name must be less than 100 characters'
  }

  if (values.firstName && values.firstName.length > 100) {
    errors.firstName = 'First Name must be less than 100 characters'
  }

  if (values.lastName && values.lastName.length > 100) {
    errors.lastName = 'Last Name must be less than 100 characters'
  }

  if (values.email && !EmailValidator.test(values.email)) {
    errors.email = 'Invalid email'
  }

  if (values.primaryPhone && !PhoneValidator(values.primaryPhone)) {
    errors.primaryPhone = 'Invalid Phone Number'
  }

  return errors
}
